import React, { useEffect, useState, useMemo } from 'react'
import "./specialItems.css"
import { IconButton, Skeleton, TextField, InputAdornment } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch, useSelector } from 'react-redux';
import { deleteListSpecialItemsAPI, editListSpecialItemsAPI, listSpecialItemsAPI, specialItemsSingleView } from './specialItemsApi';
import { setIsEditClicked, storeSpecialItemList, storeSpecialItemSingleList } from './specialItemsSlice';
import { useNavigate } from 'react-router-dom';
import ComboPriceTag from './components/ComboPriceTag';
function SpecialItems() {
    
    const dispatch=useDispatch()
    const navigate=useNavigate()
    const [searchQuery, setSearchQuery] = useState('')

    const decimalPosition=localStorage.getItem("decimalPosition")
    
    const userInfo=useSelector((state)=>state.loginResponseSlice.value)
    const {specialItemsList,tableLoading}=useSelector((state)=>state.specialItemsSlice)
    
    // Filter and sort special items based on search query
    const filteredAndSortedItems = useMemo(() => {
        let items = [...(specialItemsList || [])]
        
        // Filter by search query
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim()
            items = items.filter(item => {
                // Search in item name
                if (item?.name?.toLowerCase().includes(query)) return true
                // Search in product names within the item
                if (item?.productList?.some(p => p?.productName?.toLowerCase().includes(query))) return true
                return false
            })
        }
        
        // Sort alphabetically by name
        items.sort((a, b) => (a?.name || '').localeCompare(b?.name || ''))
        
        return items
    }, [specialItemsList, searchQuery])
  
    const createBtnClicked=()=>{
        dispatch(storeSpecialItemSingleList(null))
        navigate("create")
        localStorage.removeItem("singleViewById")
    }
    const InitialAPICalls=()=>{
        listSpecialItemsAPI({branchId:userInfo?.branchPk})
        dispatch(setIsEditClicked(false))
        localStorage.removeItem("singleViewById")
    }

    const editList=(row)=>(e)=>{

        const list=[...specialItemsList]
        // Find the correct index in the original list by _id
        const originalIndex = list.findIndex(item => item?._id === row?._id)
        if (originalIndex === -1) return
        
        const updatedItem = { ...list[originalIndex], status:e.target.checked };
        list[originalIndex] = updatedItem;
        dispatch(storeSpecialItemList(list))
   
        let editPayload={
            status:e.target.checked,
            _id:row?._id
        }


        editListSpecialItemsAPI(editPayload,InitialAPICalls)
    }

    const singleListClick=(row)=>()=>{
        let actions=()=>{
            navigate("create")
            localStorage.setItem("singleViewById",row?._id)
        }
        specialItemsSingleView({id:row?._id},actions)
    }
    
    const clickDeleteList=(id)=>()=>{
        deleteListSpecialItemsAPI({_id:id},InitialAPICalls)
    }
    useEffect(()=>{
        InitialAPICalls()
    },[])
    return (
    <div className="global-page-parent-container special-items-ctn">
        <div
            className="global-white-bg-container special-items-head justify-space-between">
            <h3>Special Items</h3>
            <div className="special-items-actions">
                <TextField
                    size="small"
                    placeholder="Search special items..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon style={{ color: '#888' }} />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        width: '250px',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                        }
                    }}
                />
                <button
                onClick={createBtnClicked}
                className="create-button-blue">Create</button>
            </div>
        </div>
        <div className='lists'>
            {
            tableLoading?
            (
            [...Array(3)].map((r)=>(
                <div key={r} className="list-cards">
                    <Skeleton width="100%" height={"40px"} />
                    <div className="list-card-items">
                        {
                            [...Array(5)].map((r) => (
                                <p><Skeleton width={"100%"} /></p>
                            ))
                        }
                    </div>
                </div>
            ))
           )
            
            :
            filteredAndSortedItems.length!==0?
            filteredAndSortedItems.map((r,i)=>(
                <div 
                key={i} className={`list-cards ${!r.status && "disabled-lists"}` }>
                <div className="justify-space-between">
                    <p 
                    onClick={singleListClick(r)}
                    className='head'>{r?.name}</p>
                    <div className="btn-ctn">
                        <input
                        className="toggle-checkbox"
                        type={"checkbox"}
                        checked={r?.status}
                        onChange={editList(r)}
                        name="purchaseReport"
                    />
                    {
                        r?.isCombo && <ComboPriceTag amount={Number(r?.comboPrice)?.toFixed(decimalPosition)}/>
                    }
                    </div>
                </div>

                <div 
                onClick={singleListClick(r)}
                className="list-card-items">
                    {
                        r?.productList.map((item, idx)=>(
                            <div key={item?._id || idx} className='justify-space-between' style={{border:"none"}}>
                                <p style={{flex: 1, textAlign: "left"}}>{item?.productName}</p>
                                <p style={{minWidth: "50px", textAlign: "right"}}>{(r?.isCombo===true)? item?.qty:item?.offerPrice}</p>
                            </div>
                        ))
                    }
                </div>
                </div>
            ))
            :
            <div className="center-div" style={{ height: "30vh" ,backgroundColor:"#fff"}}>
                {searchQuery.trim() ? `No results found for "${searchQuery}"` : 'No Data'}
            </div>
            
            }  
        </div>
    </div>
  )
}

export default SpecialItems